import React from "react";
import Header4 from "./../Common/Header4";
import Footer2 from "./../Common/Footer2";
import Slider2 from "./../Elements/Slider2";
import About4 from "./../Elements/About4";
import Projects1 from "./../Elements/Projects1";
import Testimonials1 from "./../Elements/Testimonials1";
import ContactUs1 from "./../Elements/ContactUs1";

class Home5 extends React.Component {
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Slider2 />
          <Projects1 />
          <About4 />
          <Testimonials1 />
          <ContactUs1 />
        </div>
        <Footer2 />
      </>
    );
  }
}

export default Home5;
